import { Link } from "@fluentui/react";
import { LinkRegular } from "@fluentui/react-icons";
import { Paper } from "@mui/material";
import { DataGrid, GridColDef, GridRowsProp } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { DATA_GRID_SLOTS } from "../../BasicComponents/DataGridSlots";
import { logEvent, logException } from "../../helper/AppInsightsHelper";
import { useGetFavoriteReportsByLoginQuery } from "../../slices/ExploreReports.slice";
import { useNavigate } from "react-router-dom";

export default function FavoriteReportsGridComponent() {
  const [rows, setRows] = useState<GridRowsProp>([]);
  const [loading, setLoading] = useState(true);
  // const navigate = useNavigate();
  const { data, error } = useGetFavoriteReportsByLoginQuery({});
  const navigate = useNavigate();

  const onReportLinkClick = (reportDetails: any) => {
    const reportLink = reportDetails.reportLink;
    const reportParser = reportLink?.split("/reports")[1];
    const reportId = reportParser?.split("/")[1] || ("" as string);
    navigate(`/reportview/reportid=${reportId}`, {
      state: { reportName: reportDetails.report, reportLink: reportDetails.reportLink }
    });
  };

  const columns: GridColDef[] = [
    {
      headerName: "Report",
      field: "report",
      width: 300,
      sortable: false,
      renderCell: (params) => (
        <a
          style={{
            color: "rgb(0, 120, 212)",
            textDecoration: "none",
            fontSize: 12,
            cursor: "pointer"
          }}
          onClick={() => {
            onReportLinkClick(params.row);
          }}
        >
          {params.row.report}
        </a>
      )
    },
    {
      headerName: "Product",
      field: "product",
      width: 300,
      sortable: false
    },
    {
      headerName: "Owner",
      field: "owner",
      width: 300,
      sortable: false
    },
    {
      headerName: "Workspace",
      field: "workspace",
      width: 300,
      sortable: false
    },
    {
      headerName: "Report Link",
      field: "reportLink",
      width: 100,
      sortable: false,
      flex: 1,
      renderCell: (params) => (
        <Link
          style={{
            color: "rgb(0, 120, 212)",
            textDecoration: "none",
            fontSize: 28,
            cursor: "pointer"
          }}
          onClick={() => {
            onReportLinkClick(params.row);
          }}
        >
          <LinkRegular />
        </Link>
      )
    },
    {
      headerName: "Favorite Status",
      field: "isFavorite",
      width: 300,
      sortable: false,
      renderCell: (params) => <span>{params.value ? "⭐ Favorite" : "Not Favorite"}</span>
    }
  ];

  useEffect(() => {
    setLoading(true);
    if (data) {
      setRows(data);
      setLoading(false);

      logEvent("getFavoriteReportsByLogin API call success", "My Favorites", "FavoriteReportsGridComponent");
    }
    if (error) {
      setLoading(false);
      logException("My Favorites", "FavoriteReportsGridComponent", "getFavoriteReportsByLogin", error);
    }
  }, [data, error]);

  return (
    <Paper>
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={(row) => row.report}
        loading={loading}
        keepNonExistentRowsSelected
        hideFooterPagination
        hideFooter
        disableColumnMenu
        disableColumnFilter
        disableRowSelectionOnClick
        disableColumnSelector
        slots={{
          loadingOverlay: DATA_GRID_SLOTS.loadingOverlay,
          noRowsOverlay: DATA_GRID_SLOTS.noFavoriteReportsOverlay(!!error)
        }}
      />
    </Paper>
  );
}
